import React from "react";
import Footer from "../components/Footer/Footer";
import Sidebar from "../components/Sidebar/Sidebar";
import "./AdminLayoutV2.css";
import NavTop from "../components/Navigation/NavTop";
import { Outlet, useLocation } from "react-router-dom";

const AdminLayoutV2 = () => {
  const { pathname } = useLocation();
  const hideFooter = pathname.startsWith("/watchboard") || pathname.startsWith("/customers");
  console.log(hideFooter);
  return (
    <div className="admin-main-layout">
      <NavTop />

      <div className="admin-main-layout-content">
        <Sidebar />
        <div className="" style={{ minWidth: "85%", maxWidth: "100%", marginLeft: "15%" }}>
          <div>
            <Outlet />
          </div>
        </div>
      </div>
      {!hideFooter && <Footer />}
    </div>
  );
};

export default AdminLayoutV2;
